import * as React from 'react';

import type {CoreEntityType} from 'nutshell-core/types';

import {Button} from 'shells/button/button';
import {Dialog} from 'shells/dialog/dialog';
import {Popover} from 'shells/popover/popover';

// @ts-expect-error
import {mapEntityType} from '../../../entities/helpers';

import {LeadMergeModal} from './lead-merge-modal';

export type Props = {
    omittedCount: number;
    selectedCount: number;
    maxMergeCount: number;
    onMerge: () => void;
    entityType: CoreEntityType;
    massSelect: boolean;
    displayName: string;
    onMergeLeads: () => void;
    allItems: any[];
    selectedItems: any[];
};

export function MergeButton(props: Props) {
    const [showMergeError, setShowMergeError] = React.useState(false);
    const [showLeadMergeModal, setShowLeadMergeModal] = React.useState(false);
    const [showMergeDialog, setShowMergeDialog] = React.useState(false);

    const mergeRef = React.useRef(null);

    const handleMergeClick = () => {
        const {omittedCount, selectedCount, maxMergeCount} = props;

        const isMergePossible =
            selectedCount <= maxMergeCount && !omittedCount && selectedCount > 1;

        if (!isMergePossible) {
            setShowMergeError(true);

            return;
        }

        if (props.entityType === 'leads') {
            setShowLeadMergeModal(true);
        } else {
            setShowMergeDialog(true);
        }
    };

    const handleMerge = () => {
        if (
            (props.omittedCount < 1 || props.selectedCount > 1) &&
            !(props.selectedCount > props.maxMergeCount)
        ) {
            props.onMerge();
            setShowMergeDialog(false);
        }
    };

    return (
        <>
            <Button
                getButtonRef={mergeRef}
                variant='secondary'
                size='big'
                disabled={props.omittedCount > 0 || props.selectedCount < 2}
                onClick={handleMergeClick}
            >
                Merge
            </Button>
            {showMergeError && (
                <Popover
                    anchor={mergeRef.current}
                    isDialog={true}
                    onBlur={() => {
                        setShowMergeError(false);
                    }}
                    bodyColor='error'
                >
                    Can’t merge more than {props.maxMergeCount} {mapEntityType(props.entityType)} at
                    a time
                </Popover>
            )}
            {showLeadMergeModal && (
                <LeadMergeModal
                    onMergeLeads={props.onMergeLeads}
                    allItems={props.allItems}
                    selectedItems={props.selectedItems}
                    onClose={() => setShowLeadMergeModal(false)}
                />
            )}
            {showMergeDialog && (
                <Dialog
                    anchor={mergeRef.current}
                    isWarning={props.massSelect}
                    question={`Are you certain you want to merge ${props.selectedCount} ${props.displayName}?`}
                    onPrimary={handleMerge}
                    onSecondary={() => setShowMergeDialog(false)}
                />
            )}
        </>
    );
}
